import Grid from "@mui/material/Grid2";
import React from "react";
import { Skeleton, Stack } from "@mui/material";

export const SiteSkeleton: React.FC = () => {
  return (
    <Grid container spacing={2} sx={{ pb: 4 }}>
      <Grid
        size={12}
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        mb={1}
      >
        <Skeleton variant="rounded" width={182} height={50} />
        <Stack direction="row" spacing={2}>
          <Skeleton variant="rounded" width={120} height={50} />
          <Skeleton variant="rounded" width={120} height={50} />
          <Skeleton variant="rounded" width={120} height={50} />
        </Stack>
      </Grid>

      <Grid size={12}>
        <Skeleton variant="rounded" height={68} />
      </Grid>

      <Grid size={4}>
        <Skeleton variant="rounded" height={542} />
      </Grid>

      <Grid size={8}>
        <Skeleton variant="rounded" height={542} />
      </Grid>

      <Grid size={12}>
        <Skeleton variant="rounded" height={48} />
      </Grid>

      <Grid size={12}>
        <Skeleton variant="rounded" height={56} />
      </Grid>

    </Grid>
  );
};
